/**
 * Whether product analytics (PostHog, Mixpanel) should initialise.
 *
 * **Enabled when:** `parseProductAnalyticsOverride(override)` **or** `isProduction` is true (logical OR).
 * Use the override to turn analytics on temporarily in local / dev / preview without marking the whole app “production”.
 *
 * **Client bundles (Vite / Next `NEXT_PUBLIC_*`):** override values are fixed at **build time**. Changing env on the host requires a rebuild or dev server restart.
 * **API:** `PRODUCT_ANALYTICS_ENABLED` is read at process startup (restart after change).
 *
 * | App       | Override env |
 * |-----------|----------------|
 * | Dashboard | `VITE_PRODUCT_ANALYTICS_ENABLED` |
 * | Landing   | `NEXT_PUBLIC_PRODUCT_ANALYTICS_ENABLED` |
 * | API       | `PRODUCT_ANALYTICS_ENABLED` |
 */
export function parseProductAnalyticsOverride(raw) {
    if (raw == null)
        return false;
    const v = String(raw).trim().toLowerCase();
    return v === "1" || v === "true" || v === "yes" || v === "on";
}
/**
 * @returns `true` if the explicit override is truthy **or** `isProduction` is `true`.
 */
export function isProductAnalyticsEnabled(params) {
    const { isProduction, override } = params;
    if (typeof override === "boolean") {
        if (override)
            return true;
    }
    else if (parseProductAnalyticsOverride(override ?? undefined)) {
        return true;
    }
    return isProduction;
}
